import styled, { css } from 'styled-components';
import { colors, isDefaultThemeMode } from 'core/theme';
import { ThumbnailBase } from '../Thumbnail/styled';
import { padding } from '../../constants';

const height = ({compact}) => (
  compact ? 298 : 450
);

export const StyledThumbnail = ThumbnailBase.extend`
  ${props => isDefaultThemeMode(props) && css`
    background-color: ${colors.HIGHLIGHT};
  `};
  height: ${height}px;
  position: relative;
`;

const accessibilityMode = (props) => {
  if (!isDefaultThemeMode(props)) {
    return css`
      & > button {
        background-color: ${colors.background};
        color: ${colors.text};
      }

      &:hover > button,
      &:active > button {
        background-color: ${colors.text};
        color: ${colors.background};
      }
    `;
  }
};

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgba(0,0,0,0.6) 0%,rgba(0,0,0,0.3) 30%,rgba(0,0,0,0) 100%);

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: ${padding}px;

  & > button {
    font-size: ${({compact}) => compact ? 1 : 1.5}em;
    min-width: 0;
    text-align: left;
    transform: translate(-0.5em, 8px);

    &,
    &:hover {
      color: ${colors.W};
    }

    &:active {
      background-color: transparent;
      color: ${colors.W};
    }
  }

  ${accessibilityMode};
`;



// WEBPACK FOOTER //
// ./src/elements/Card/components/ThumbnailCover/styled.js